import TaskSubData from "../../DesignTaskSubData";

export default class Finish extends TaskSubData {

    // override
    validateSelf(): void {
        return;
    }
}